import React from "react";
import { Button, Card, Input, Textarea } from "@material-tailwind/react";

function AccordionCustomIcon() {
  return (
    <>
      <div className="w-full flex justify-center">
        <div className="px-3 w-full xl:w-1/2 gap-y-10 py-10">
          <Card className="border-black p-6 bg-opacity-30 shadow-2xl">
            <div>
              <div className="">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label
                      htmlFor="first-name"
                      className="block text-sm font-medium text_OpenSans-VariableFont_wdth"
                    >
                      First name
                    </label>
                    <Input
                      type="text"
                      id="first-name"
                      name="first-name"
                      required
                      className="mt-1 block w-full rounded-md shadow-sm focus:border-customMaroon-40"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="last-name"
                      className="block text-sm font-medium text_OpenSans-VariableFont_wdth"
                    >
                      Last name
                    </label>
                    <Input
                      type="text"
                      id="last-name"
                      name="last-name"
                      required
                      className="mt-1 block w-full rounded-md shadow-sm focus:border-customMaroon-40"
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="email"
                    className=" mt-3 block text-sm font-medium text_OpenSans-VariableFont_wdth"
                  >
                    Email address
                  </label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="mt-1 block w-full rounded-md shadow-sm focus:border-customMaroon-40"
                  />
                </div>
                <div>
                  <label
                    htmlFor="message"
                    className="block mt-3 text-sm font-medium text_OpenSans-VariableFont_wdth"
                  >
                    Message
                  </label>
                  <Textarea
                    id="message"
                    name="message"
                    required
                    className="mt-1 block w-full rounded-md shadow-sm focus:border-customMaroon-40"
                  ></Textarea>
                </div>
                <div className="flex justify-end">
                  <Button
                    type="submit"
                    className="w-full xl:w-auto py-4 px-4 rounded-md shadow-sm mt-5
                                        text-white hover:text-black
                                        bg-gradient-to-r from-customBeige-45 to-customBeige-45 
                                        hover:from-customBeige-55 hover:to-customBeige-55
                                        transition hover:duration-500  ease-in-out
                                        focus:outline-none
                                        focus:ring-2 focus:ring-customBeige-30"
                  >
                    Send Message
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default AccordionCustomIcon;
